import { render, staticRenderFns } from "./TaskRunTooltip.vue?vue&type=template&id=669f5cc5&scoped=true&"
import script from "./TaskRunTooltip.vue?vue&type=script&lang=js&"
export * from "./TaskRunTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TaskRunTooltip.vue?vue&type=style&index=0&id=669f5cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f5cc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
